import TaskTypesTemplate from '../../../components/Templates/TaskTypes/TaskTypesTemplate';
/**
 * @page TaskTypes.tsx
 * @description admin page to see the task type.
 * @return { page }
 */
function TaskTypes() {
  return <TaskTypesTemplate />;
}

export default TaskTypes;
